// src/features/chales/components/ExportGuestsModal.jsx
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "components/ui/dialog";
import { Button } from "components/ui/button";
import { Copy } from "lucide-react";
import toast from "react-hot-toast";

const ExportGuestsModal = ({ isOpen, onClose, chales, selectedDate }) => {
  const isSameDate = (d1, d2) => {
    if (!d1 || !d2) return false;
    const date1 = new Date(d1);
    const date2 = new Date(d2);
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  const checkInChales = chales
    .filter((c) => !c.isAvailable && isSameDate(c.checkInDate, selectedDate))
    .sort((a, b) => a.chaletNumber - b.chaletNumber);

  const generateFormattedList = () => {
    let text = "*LISTA CHALÉS*\n\n";

    const groups = {};
    checkInChales.forEach((c) => {
      const phone = c.phoneInfo || "sem-telefone-" + c.reservationId;
      if (!groups[phone]) {
        groups[phone] = {
          chaletNumbers: [c.chaletNumber],
          responsibleName: c.responsibleName,
          cpf: c.cpf,
          address: c.address,
          guestList: c.guestList,
        };
      } else {
        groups[phone].chaletNumbers.push(c.chaletNumber);
        // Em caso de múltiplos chalés, priorizar o que tiver dados preenchidos
        if (!groups[phone].responsibleName && c.responsibleName) {
          groups[phone].responsibleName = c.responsibleName;
          groups[phone].cpf = c.cpf;
          groups[phone].address = c.address;
          groups[phone].guestList = c.guestList;
        }
      }
    });

    const sortedGroups = Object.values(groups).sort(
      (a, b) => Math.min(...a.chaletNumbers) - Math.min(...b.chaletNumbers),
    );

    sortedGroups.forEach((g) => {
      const chaletLabel = g.chaletNumbers
        .sort((a, b) => a - b)
        .map((n) => String(n).padStart(2, "0"))
        .join(", ");

      text += `*CHALÉ ${chaletLabel}*\n\n`;
      if (g.responsibleName) {
        text += `${g.responsibleName}\n`;
        text += `CPF: ${g.cpf || ""}\n`;
        text += `${g.address || ""}\n\n`;
      }
      if (g.guestList) {
        text += `${g.guestList}\n\n`;
      }
    });

    return text;
  };

  const handleCopy = () => {
    const text = generateFormattedList();
    navigator.clipboard.writeText(text);
    toast.success("Lista copiada para a área de transferência!");
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-full h-[100dvh] max-h-none sm:h-auto sm:max-h-[85vh] sm:max-w-[600px] p-0 border-0 sm:border rounded-none sm:rounded-lg overflow-hidden flex flex-col">
        <DialogHeader className="px-6 py-4 border-b border-slate-100 dark:border-border shrink-0">
          <DialogTitle>Exportar Lista de Hóspedes</DialogTitle>
        </DialogHeader>
        <div className="px-6 py-6 overflow-y-auto flex-1">
          <div className="bg-gray-50 dark:bg-card p-4 rounded-md border">
            <pre className="whitespace-pre-wrap font-sans text-sm">
              {generateFormattedList()}
            </pre>
          </div>
        </div>
        <DialogFooter className="px-6 py-4 border-t border-slate-100 dark:border-border bg-slate-50 dark:bg-card shrink-0">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto min-h-[44px]">
            Fechar
          </Button>
          <Button onClick={handleCopy} className="w-full sm:w-auto min-h-[44px] flex gap-2">
            <Copy className="h-4 w-4" />
            Copiar Lista
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExportGuestsModal;
